import React from "react";
import {
  CsplTable as Table,
  DatePicker,
  FieldDropSide,
  Select,
  Link,
  SearchableList,
  MultiSelectDropdown,
} from "../../../components";
import TableHead from "../../../components/CsplTable/TableHead";
import { getTwoDecimalPlaces } from "../../../utils";

const columns = [
  {
    label: "Particulars",
    className: "table-width-40",
    columnName: "particulars",
  },
  {
    label: "Opening balance",
    className: "table-width-20",
    columnName: "openingBalance",
  },
  {
    label: "Transactions",
    className: "table-width-20",
    columnName: "transactionsForPeriod",
  },
  {
    label: "Closing balance",
    className: "table-width-20",
    columnName: "closingBalance",
  },
];
const data = [
  {
    particulars: "Employee Contribution Loan payable A/c",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Employee  Contribution Loan Interest payable A/C",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Employer Contribution Loan payable - Vested A/C",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Employer Contribution Loan Interest payable - Vested A/C",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
];
const data2 = [
  {
    particulars: "Employee Contribution Loan payable A/c",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Employer Contribution Loan payable - Vested A/C",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
];
const openingBalance = {
  particulars: "Opening balance total",
  openingBalance: 340123,
  transactionsForPeriod: 102123,
  closingBalance: 442246,
};
const repaymentTotal = {
  particulars: "Repayments total",
  openingBalance: 340123,
  transactionsForPeriod: 102123,
  closingBalance: 442246,
};
const finalParticulars = [
  {
    particulars: "Loan principal outstanding balance",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Loan Interest outstanding balance",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
  {
    particulars: "Total Loan outstanding balance",
    openingBalance: 340123,
    transactionsForPeriod: 102123,
    closingBalance: 442246,
  },
];
export const LoanStatementTable = (props) => {
  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          {columns.map((e, i) => (
            <Table.Th className={e.className}>{e.label}</Table.Th>
          ))}
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        <Table.Tr>
          <Table.Th className="table-sub-header">Opening Balance</Table.Th>
        </Table.Tr>
        {data.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={f.className}>{e[f.columnName]}</Table.Td>
              ) : (
                <Table.Td className={f.className}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className={`${f.className} table-total-value`}>
                {openingBalance[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className={`${f.className} table-total-value`}>
                ${getTwoDecimalPlaces(openingBalance[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        <Table.Tr>
          <Table.Th className="table-sub-header">Repayments</Table.Th>
        </Table.Tr>
        {data2.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={f.className}>{e[f.columnName]}</Table.Td>
              ) : (
                <Table.Td className={f.className}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
        <Table.Tr>
          {columns.map((f, j) =>
            f.columnName === "particulars" ? (
              <Table.Td className={`${f.className} table-total-value`}>
                {repaymentTotal[f.columnName]}
              </Table.Td>
            ) : (
              <Table.Td className={`${f.className} table-total-value`}>
                ${getTwoDecimalPlaces(repaymentTotal[f.columnName])}
              </Table.Td>
            )
          )}
        </Table.Tr>
        {finalParticulars.map((e, i) => (
          <Table.Tr>
            {columns.map((f, j) =>
              f.columnName === "particulars" ? (
                <Table.Td className={`${f.className} table-total-value`}>
                  {e[f.columnName]}
                </Table.Td>
              ) : (
                <Table.Td className={`${f.className} table-total-value`}>
                  ${getTwoDecimalPlaces(e[f.columnName])}
                </Table.Td>
              )
            )}
          </Table.Tr>
        ))}
      </Table.Tbody>
    </Table>
  );
};
